import { render } from "./FeedbackTags.vue?vue&type=template&id=ed51cb90&scoped=true"
import script from "./FeedbackTags.vue?vue&type=script&lang=js"
export * from "./FeedbackTags.vue?vue&type=script&lang=js"

import "./FeedbackTags.vue?vue&type=style&index=0&id=ed51cb90&scoped=true&lang=css"

import exportComponent from "/home/devops/vsts-agent/_work/20/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed51cb90"]])

export default __exports__